export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/ee9346a7a9322dc42520ebdf49402b79.svg";